import { initCalculator } from './controller/calc-controller'

window.IGREQuickQuote = { init: initCalculator }